// Select the gender you are seeking when selecting your own gender on the registration form

// @TODO: `gender-selector.js` remove dev comments once accepted into production
// 1. If we need more specificity here we can add the following:
//    if (target.name === 'gender' && target.form.name === 'registration')
// 2. Do we need to remove this listener once a user
//    has manuallychanged the value of gender_w?
// 3. We rely on a hidden field that sets the value of seek per siteDomain
// 4. For a simpler implementation query the domain from location.origin
//    and set the default and seek values here

window.addEventListener('change', function (e) {
  var target = e.target
  if(target.form){
    var field = target.form.elements.gender_w
    if (target.name === 'gender' && field && target.form.elements.seek) {
      var seek = target.form.elements.seek.value
      field[0].checked = target.value !== seek
      field[1].checked = target.value === seek
    }
  }
})

var onclickHandler = function (e) {
  if (/gender/.test(e.target.name)) {
    e.stopImmediatePropagation()
  }
}

window.addEventListener('click', onclickHandler, true)
